import { useEffect, useState } from 'react';
import userSlice from 'app/store/user/user.slice';
import { _isEmpty } from 'app/utils/helpers';

export const useLoadCurrentUser = (): boolean => {
    const { user, isAuthenticated, getUser } = userSlice();
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (isAuthenticated && _isEmpty(user)) {
            // A rejected bootstrap previously escaped as an unhandled promise. The
            // interceptor handles expired tokens; other failures use the error page.
            void getUser().catch(() => setFailed(true));
        }
    }, [user, isAuthenticated, getUser]);

    return failed;
};
